// Utility functions for safe array operations and debugging

export function invariantArray<T>(name: string, value: T[] | undefined | null): asserts value is T[] {
  if (!Array.isArray(value)) {
    console.group('%c[Invariant violation]', 'color:crimson;font-weight:bold;');
    console.log(`Expected "${name}" to be array, got:`, value);
    console.log(`Type:`, typeof value);
    console.log(`Value:`, value);
    // Stack trace to see who's calling
    console.log(new Error(`Invariant: ${name} is not array`).stack);
    console.groupEnd();
    throw new Error(`Invariant: ${name} is not an array. Got: ${typeof value}`);
  }
}

export function safeLength(v: any, label: string): number {
  const len = (Array.isArray(v) || typeof v === 'string') ? v.length : undefined;
  if (len === undefined) {
    console.warn(`[safeLength] ${label} has no length, got:`, v);
    console.log(new Error().stack);
  }
  return len ?? 0;
}

export function safeLengthDebug(v: any, label: string): number {
  console.log(`[safeLengthDebug] Checking ${label}:`, {
    value: v,
    isArray: Array.isArray(v),
    isString: typeof v === 'string',
    type: typeof v,
    length: v?.length
  });
  return safeLength(v, label);
}

export function logModuleInit(moduleName: string) {
  console.log(`%c[INIT] ${moduleName} loaded`, 'color:green;font-weight:bold;');
}
